import { UserMappingListSkeleton } from './tabs/UserMappingListSkeleton';

/** Chunk-fetch placeholder for Team integration sub-tabs (Cursor, Slack, …). */
export function IntegrationSubTabSkeleton() {
  return <UserMappingListSkeleton />;
}
